export const points = [
  {
    id: 1,
    name: 'detergentArea',
    position: { x: 0.20, y: 1.55, z: 3.60 },
    child: {
      name: 'detergentChildInfo',
      infos: [
        { id: '1-1', name: 'bref', position: { x: 0.23, y: 1.55, z: 2.65 } }
      ]
    }
  },
  {
    id: 2,
    name: 'hairCareArea',
    position: { x: -3.32, y: 1.95, z: -1.52 },
    child: {
      name: 'hairCareChildInfo',
      infos: [
        { name: 'oil_ultime', position: { x: -3.40, y: 1.75, z: -3.65 } },
        { name: 'blondme', position: { x: -3.40, y: 1.05, z: -3.65 } },
        { name: 'essensity', position: { x: -2.25, y: 1.75, z: -2.82 } },
        { name: 'fibre_clinix', position: { x: -2.25, y: 1.10, z: -1.25 } },
        { name: 'osis', position: { x: -2.25, y: 1.45, z: -1.68 } },
        { name: 'session', position: { x: -2.25, y: 1.05, z: -1.82 } }
      ]
    }
  },
  {
    id: 3,
    name: 'adhesiveArea',
    position: { x: 3.06, y: 1.65, z: 3.29 },
    child: {
      name: 'adhesiveChildInfo',
      infos: [
        { id: '1-1', name: 'adhesive_1_1', position: { x: 4.06, y: 2.25, z: 3.45 } }
      ]
    }
  },
  {
    id: 4,
    name: 'centerArea',
    position: { x: 0, y: 1.5, z: 0 },
    child: {
      name: 'lobbyArea',
      infos: [
        { name: 'persil_3_in_1', position: { x: 1.28, y: 2.00, z: 2.35 } },
        { name: 'persil_4_in_1', position: { x: -0.25, y: 2.00, z: 1.50 } },
        { name: 'renuzit', position: { x: -1.80, y: 1.85, z: 0.28 } },
        { name: 'perwoll', position: { x: -1.60, y: 1.10, z: -0.85 } },
        { name: 'pril', position: { x: 2.58, y: 1.58, z: -0.60 } },
        { name: 'green', position: { x: 2.90, y: 1.60, z: 1.05 } },
        { name: 'somat', position: { x: 1.80, y: 1.85, z: -1.35 } }
      ]
    }
  }
  // {
  //   id: 5,
  //   name: 'rightArea',
  //   position: { x: 1.95, y: 1.00, z: 0 },
  //   child: {}
  // }
]

export const canmeraAreaPox = [
  { id: 1, position: { x: -1.12, y: 1.72, z: 9.81 } },
  { id: 2, position: { x: -4.33, y: 2.17, z: 3.27 } },
  { id: 3, position: { x: -0.65, y: 1.76, z: 6.50 } },
  // { id: 4, position: { x: 2.46, y: 1.30, z: 2.57 } },
  // { id: 4, position: { x: -0.72, y: 1.50, z: -1.00 } },
  { id: 4, position: { x: 1.25, y: 2.00, z: 0.45 }, aspect: 0.45 },
  { id: 5, position: { x: -0.25, y: 1.55, z: 2.32 } }
]

export const dataSwipeProduct = {
  bref: [
    {
      title: 'Bref ®  妙力  多效洁厕魔力球',
      cover: 'static/images/bref_1.jpg',
      text: [
        { title: '', content: '告别手刷，妙趣生香；自然芳香，长效清新。', desc: '' },
        { title: '', content: '四效合一，升级洁厕新生活：强效除菌、防止水垢，清洁泡沫，长效清新。', desc: '' },
        { title: '', content: '4款香型随心选：柠檬清香、浪漫花香、海洋香氛、薰衣草。', desc: '' }
      ],
      list: []
    },
    {
      title: 'Bref ®  妙力  多效洁厕魔力球香氛奢宠款',
      cover: 'static/images/bref_2.jpg',
      text: [
        { title: '', content: '告别手刷，妙趣生香；自然芳香，长效清新。', desc: '' },
        { title: '', content: '四效合一，升级洁厕新生活：强效除菌，防止水垢，清洁泡沫，长效清新。', desc: '' },
        { title: '', content: '2款高级香调随心选：幽谷木兰、月光茉莉。', desc: '' }
      ],
      list: []
    },
    {
      title: 'Bref ®  妙力  多效洁厕魔力球',
      cover: 'static/images/bref_3.jpg',
      text: [
        { title: '', content: '告别手刷，妙趣生香；双重香氛，持久留香。', desc: '' },
        { title: '', content: '四效合一，开启洁厕新生活：留香持久，清洁泡沫，强效除菌，防止水垢。', desc: '' },
        { title: '', content: '2款香氛随心选：莲池落竹、果园荷氛。', desc: '' }
      ],
      list: []
    }
  ],
  persil_3_in_1: [
    {
      title: 'Persil ®  宝莹 3合1 强效洗衣凝珠',
      cover: 'static/images/persil_1.jpg',
      text: [
        { title: '', content: '一抛多效，洁净焕新，满足人们对高效便捷洗衣的需求。深层清洁，除菌抑菌并持久留香，呵护家人健康。', desc: '' },
        { title: '', content: '独特酵素浓缩配方，去除深层污渍。护色柔顺，呵护纤维，轻松锁住衣物本色。自调天然植萃，富含水溶性植物精华，保持衣物持久清新。', desc: '' },
        { title: '', content: '采用进口高分子水溶包裹，遇水迅速溶解。支持15分钟快洗模式，省时省事，节水节能。', desc: '' }
      ],
      list: []
    }
  ],
  persil_4_in_1: [
    {
      title: 'Persil ®  宝莹 4合1洗衣凝珠',
      cover: 'static/images/persil_2.jpg',
      text: [
        { title: '', content: '4合1有氧小飞碟带来洁净新概念，柔顺纤维，护色亮彩，深层清洁，持久清新。', desc: '' },
        { title: '', content: '采用进口高分子水溶包裹，遇水迅速溶解。释放衣物洁净清新菁华。', desc: '' }
      ],
      list: []
    }
  ],
  renuzit: [
    {
      title: 'Renuzit®  蕊氛 空气清新剂',
      cover: 'static/images/renuzit_1.jpg',
      text: [
        { title: '', content: '空气清新剂，有效祛除异味，如风清新，无论是客厅、卫生间还是车上都可以芳香萦绕，让您和您的家人一整天心情愉悦。', desc: '' },
        { title: '', content: '多款香型：雨后清新、夏威夷绿洲、花漾绽放、塔西提微风。', desc: '' },
        { title: '', content: '天然成分来源，30天持久清新。天然持久散香，多种香型可选，安全祛苯除醛。', desc: ' * 根据汉高测试方法48小时可去除甲醛40.9%和苯25.5%' }
      ],
      list: []
    }
  ],
  perwoll: [
    {
      title: 'Perwoll ®   绮纺 焕新修护洗衣凝乳',
      cover: 'static/images/perwoll_1.jpg',
      text: [
        { title: '', content: 'Perwoll®绮纺焕新修护洗衣凝乳，致力于满足都市女性对时尚精致衣物的洗护需求，焕发衣物光彩，时刻散发自信光彩。', desc: '' },
        { title: '', content: '复合纤维精粹，有效抚平毛躁、拒绝起球；强韧纤维力量，防止衣物变形，焕新修护，让爱衣宛如初见。', desc: '' },
        { title: '', content: '针对不同色彩织物，Perwoll®绮纺推出三色修护洗衣凝乳：白瓶适用白色及浅色衣物，亮白祛黄；黑瓶适用黑色及深色衣物，固色更亮泽；红瓶适用彩色衣物，鲜亮防褪色。', desc: '' }
      ],
      list: []
    }
  ],
  pril: [
    {
      title: 'Pril ®  玉莹 食用级小苏打洗洁精',
      cover: 'static/images/pril_1.jpg',
      text: [
        { title: '', content: '采用食用级天然小苏打，绿色洁净力强效去油，多用途清洁，一瓶搞定。', desc: '' },
        { title: '', content: '去除表面残留农药，温和清洁不伤手，去油除垢不留残渍，安全洁净无化学残留。', desc: '' },
        { title: '', content: '2种香型随心选：柠檬果香、清新草本。', desc: ' ' }
      ],
      list: []
    },
    {
      title: 'Pril ®  玉莹 高效洗碗精芦荟香(敏感肤质)',
      cover: 'static/images/pril_2.jpg',
      text: [
        { title: '', content: '采用食用级天然小苏打，绿色洁净力强效去油，多用途清洁，一瓶搞定。', desc: '' },
        { title: '', content: '去除表面残留农药，温和清洁不伤手，去油除垢不留残渍，安全洁净无化学残留。', desc: '' },
        { title: '', content: '2种香型随心选：柠檬果香、清新草本。', desc: ' ' }
      ],
      list: []
    }
  ],
  somat: [
    {
      title: 'Somat  强效去油洗碗液',
      cover: 'static/images/somat_1.jpg',
      text: [
        { title: '', content: '双泵多效，为顽固污渍而生。', desc: '' },
        { title: '', content: '12效合一，免盐免剂。采用速溶配方，超强去焦渍。萃取柠香，安全除异味。加快干燥，洁净更光亮。机体养护，轻松除油垢。灵活用量，精打细算。', desc: '' }
      ],
      list: []
    },
    {
      title: 'Somat  多效合一洗碗块',
      cover: 'static/images/somat_2.jpg',
      text: [
        { title: '', content: '多效合一，为顽固污渍而生。日常洗碗，大型洗碗机均可适用。', desc: '' },
        { title: '', content: '黄金12效，一块搞定：超强去焦渍，轻松除垢，深层清洁无异味。加速干燥，防止水斑。机体养护，轻松除油垢。', desc: '' },
        { title: '', content: '蓝色清洁块进行软化清洁，抑制水垢生成，养护洗碗机机体；红色养护块去除油污异味，增添洁净芳香。', desc: '' }
      ],
      list: []
    },
    {
      title: 'Somat  洗碗机清洁块',
      cover: 'static/images/somat_3.jpg',
      text: [
        { title: '', content: '深入清洁机体洗碗，事半功倍。', desc: '' },
        { title: '', content: '蓝白双效：蓝色消除水渍，白色强力去污。可与Somat多效合一洗碗块、Somat强效去油洗碗液配合使用，省水省电省时省力。', desc: '' }
      ],
      list: []
    },
    {
      title: 'Somat 增亮碗碟专用清洁剂',
      cover: 'static/images/somat_4.jpg',
      text: [
        { title: '', content: '晶亮璀璨，碗如新生。五效合一，让餐具干燥又闪亮。', desc: '' },
        { title: '', content: '餐具增亮，强力干燥，机器光亮，双重清新。', desc: '' }
      ],
      list: []
    }
  ],
  osis: [
    {
      title: 'Osis',
      cover: 'static/images/osis_1.jpg',
      text: [
        { title: '', content: 'OSIS+，为创意而生。作为第一个造型决定产品的造型品系列，潮流风向般的产品不仅带来时尚灵感和独一无二的想法，激发你的创意。同时为你的沙龙打造独特造型，让你的沙龙成为“创意之源”。', desc: '' },
        { title: '', content: 'OSIS+尚丝系列能够协助造型师创造最前卫潮流的造型。在OSIS+尚丝系列的辅助下，造型师能够为每一位客人打造出同时具有个性和质感的前卫造型，每一款造型都“独一无二”。造型师每天需要接触造型的“形状”、“质感”，更需要自我造型意识，他们“为创造而生”，决定了他们选择尚丝造型系列。明星单品包括了施华蔻劲能定型摩丝：第一款强劲造型摩丝造型打底，打造光泽、蓬感造型，防止吹风热能损伤；', desc: '' }
      ],
      list: []
    }
  ],
  session: [
    {
      title: 'Session Label',
      cover: 'static/images/session_1.jpg',
      text: [
        { title: '', content: 'OSIS+施华蔻型格印记系列，用卓越品质和显著效果维护着其高端定位。产品线一应俱全，满足各类发型需求。型格印记系列首次强调造型三部曲：第一步用蕴含蚕丝萃取精华的多效造型乳打造完美发型，给予发丝多重保护，用海岩蓬感喷雾使头发自然蓬松，充满空气感，再用蓬发摩丝做打底；接着用蓬发造型粉和塑型发膏做造型，在保持轻盈感的同时提升发根支撑度，并使头发自然亮泽；最后用强力塑型喷发胶进行定型，从而打造百变快干造型。酷黑至尊，闪曜新生。', desc: '' }
      ],
      list: []
    }
  ],
  essensity: [
    {
      title: 'Essensity',
      cover: 'static/images/essensity_1.jpg',
      text: [
        { title: '', content: 'OSIS+施华蔻专业怡嬗染膏系列，主打高端健康植物染膏系列89%自然成分、三大高光成分：迷迭香、乳木果油、金盏花，保湿、滋养、修复秀发，强韧发丝防止断裂。低氨配方，气味温和：天然配方有效减少染发过程中及残留的刺激性气味。', desc: '' },
        { title: '四大产品特点：', content: '采用突破性科技——CTE 液晶乳化技术，带来专业的染发效果。', desc: '', dot: true },
        { title: '', content: '均匀密集渗透：有序排列的单晶结构，均匀覆盖发丝表面，上色均匀。', desc: '', dot: true }
      ],
      list: []
    }
  ],
  oil_ultime: [
    {
      title: 'Oil Ultime',
      cover: 'static/images/oil_ultime_1.jpg',
      text: [
        { title: '', content: '施华蔻专业线高端品牌欧悦缇，芳香精油奢宠，悦发悦心。', desc: '' },
        { title: '三大产品特点：', content: '萃取天然精粹：辅以精研护理配方，奢宠养护秀发。', desc: '', dot: true },
        { title: '', content: '集多个黑科技于一体：TRIBOND技术、秀发修护技术和“微乳液”技术。', desc: '', dot: true },
        { title: '', content: '国际调香师经典之作：辅以专业护理师奢宠芳香精油按摩，舒缓焦虑感和疲劳感，愉悦心灵。', desc: '', dot: true }
      ],
      list: []
    }
  ],
  fibre_clinix: [
    {
      title: 'Fibre Clinix',
      cover: 'static/images/fibre_clinix_1.jpg',
      text: [
        { title: '', content: '施华蔻专业发芯臻护系列，强韧由芯，自有光芒。专为修护因染烫漂受损秀发而研发，有效修护受损发质，增强发质，强韧发芯。', desc: '' },
        { title: '两大产品特点：', content: '发芯修护技术：Tri-bond三价离子修护技术和C21秀发修护技术。', desc: '', dot: true },
        { title: '', content: '专属定制化护理服务：五种精华素，蕴含臻宠养护成分，有针对性地解决各种秀发问题。', desc: '', dot: true }
      ],
      list: []
    }
  ],
  blondme: [
    {
      title: 'Blondme',
      cover: 'static/images/blondme_1.jpg',
      text: [
        { title: '', content: '施华蔻专业白金发用漂粉，国际发型师挚爱。产品特含发纤强韧科技，减少漂发损伤；温和成分，更好漂净底色的同时呵护秀发。', desc: '' },
        { title: '两大产品特点：', content: '9度漂浅，更好漂净底色，提升显色度，打造出彩潮色。', desc: '', dot: true },
        { title: '', content: '高端定制体验，不拘泥传统色系，定制漂发服务。', desc: '', dot: true }
      ],
      list: []
    }
  ],
  appliances: [
    {
      title: '家用电器行业解决方案',
      cover: 'static/images/appliances_1_1_1.jpg',
      text: [
        { title: '', content: '汉高为家电行业提供结构粘接、减振降噪、电子材料等全面的粘合剂解决方案，助力提升自动化水平，满足可持续发展需求。', desc: '' }
      ],
      list: []
    },
    {
      title: '家用电器行业解决方案',
      cover: '',
      text: [],
      list: [
        { title: 'BERGQUIST SIL PAD TSP K1300', intro: '高性能绝缘体，它把特殊的薄膜与填充硅橡胶结合在一起，形成具有优异绝缘性能和导热性能的产品。', cover: 'static/images/appliances_1_2_1.jpg', dot: true },
        { title: 'TECHNOMELT PUR 4661', intro: '湿气固化的反应型聚氨酯热熔粘合剂产品，应用于玻璃面板粘接，相对较长的开放时间，为客户端更加灵活的可操作需求提供保障。', cover: 'static/images/appliances_1_2_2.jpg', dot: true },
        { title: 'TECHNOMELT PUR 4662', intro: '湿气固化的反应型聚氨酯热熔粘合剂产品，快速固化，高效定位，在各种基材上表现出良好的粘接效果。', cover: 'static/images/appliances_1_2_3.jpg', dot: true }
      ]
    }
  ],
  car: [
    {
      title: '汽车行业解决方案',
      cover: 'static/images/car_2_1_1.jpg',
      text: [
        { title: '', content: '汉高提供超过300种解决方案，应用于汽车车身、内饰、电子系统、汽车电池等方面。', desc: '' },
        { title: '', content: '创新的汉高粘合剂解决方案，为汽车减重15%，帮助燃油车减少碳排放，同时也让电动车的电池更耐用。', desc: '' }
      ],
      list: []
    },
    {
      title: '汽车行业解决方案',
      cover: '',
      text: [],
      list: [
        { title: '汽车结构增强件', intro: '采用轻质高性能结构泡沫；适用于ABCD柱、门槛、车门、车身面板等位置，经证实可减少白车身及开闭件重量　40 千克以上，达到或超过NVH和碰撞安全标准。', cover: 'static/images/car_2_2_1.jpg', dot: true },
        { title: '汽车结构增强件', intro: '汉高提供适用于车灯装配和辅助零部件的粘结和发泡密封的全系列产品，如反应性 热熔、聚氨酯和其他结构胶产品。', cover: 'static/images/car_2_2_2.jpg', dot: true },
        { title: '应用于挡风雨条的汉高解决方案', intro: '汉高的防水饰条防滑涂料，快速且易应用。有效改善附着力，减少浪费和降噪。', cover: 'static/images/car_2_2_3.jpg', dot: true }
      ]
    }
  ],
  consume: [
    {
      title: '消费电子行业解决方案',
      cover: 'static/images/consume_3_1_1.jpg',
      text: [
        { title: '', content: '汉高粘合剂技术提供多达50种粘合剂解决方案，应用于移动电子设备的器件组装、结构组装、热管理和灌封等。', desc: '' },
        { title: '', content: '创新的汉高粘合剂解决方案，为汽车减重15%秉承可持续环保发展优先理念，汉高于2021年推出业内首款生物基反应型聚氨酯（PUR）热熔胶。该产品近三分之二的成分来源于可再生的植物原料，专用于消费电子设备的组装。', desc: '' }
      ],
      list: []
    },
    {
      title: '消费电子行业解决方案',
      cover: '',
      text: [],
      list: [
        { title: 'LOCTITE ABLESTIK CDF系列', intro: '应用于手机内元器件芯片封装，满足高集成度设计需求（薄封装），具有高导热高导电以及更高可靠性。', cover: 'static/images/consume_3_2_1.jpg', dot: true },
        { title: 'LOCTITE HHD 3544F', intro: '汉高首款+业内首款专为消费电子设备组装研发设计的生物基反应型PUR热熔胶，60%的成分来源于可再生的植物原料。', cover: 'static/images/consume_3_2_2.jpg', dot: true },
        { title: 'LOCTITE ECCOBOND EN 3846', intro: '应用于手机内柔性印刷电路板上器件的局部包封，提供耐高温高湿的可靠性保护；增强防水、防震和防跌落性能；提升设备使用寿命；易返工，有助于保护组件价值。', cover: 'static/images/consume_3_2_3.jpg', dot: true }
      ]
    }
  ],
  medical: [
    {
      title: '医疗行业解决方案',
      cover: 'static/images/medical_4_1_1.jpg',
      text: [
        { title: '', content: '汉高为医疗行业提供完善的粘合剂产品线、点胶和固化设备和电子材料等，助力实现安全、高效且可持续的生产装配。', desc: '' }
      ],
      list: []
    },
    {
      title: '医疗行业解决方案',
      cover: '',
      text: [],
      list: [
        { title: 'LOCTITE AA 3345', intro: '双组分室温固化丙烯酸瞬干胶，应用与针头粘接，适用于一次性医疗器械的组装。高度防潮，耐化学介质，按需固化，速度快。', cover: 'static/images/medical_4_2_1.jpg', dot: true },
        { title: 'LOCTITE AA 3921', intro: '光固化丙烯酸胶粘剂,用来粘接应力敏感塑料时可产生柔性粘接层，符合ISO10993有关医疗器械的应用要求。', cover: 'static/images/medical_4_2_2.jpg', dot: true }
      ]
    }
  ],
  furniture: [
    {
      title: '家具与建材行业解决方案',
      cover: 'static/images/furniture_5_1_1.jpg',
      text: [
        { title: '', content: '汉高提供创新环保的全屋家装粘合剂解决方案。百得(Pattex) 致力于持续打造健康家装产品，减少挥发性有机化合物 (VOCs) 等室内有害气体的释放，让施工者用得放心，消费者住得安心。', desc: '' }
      ],
      list: []
    },
    {
      title: '家具与建材行业解决方案',
      cover: '',
      text: [],
      list: [
        { title: '百得优家环保防霉中性硅酮密封胶Pattex FUSION XLT', intro: '历经五年时间研发及测试，融合了脱肟技术的良好物理性能和脱醇技术的环保性能，在施工阶段和固化后不释放挥发性有害物质，无刺激性气味，更加环保健康。', cover: 'static/images/furniture_5_2_1.jpg', dot: true },
        { title: '百得焕新水性硅胶Pattex RENEW', intro: '光固化丙烯酸胶粘剂,有不燃、绿色环保的特点。以水作为溶剂配方，减少硅胶固化时挥发性有机物VOCs的排放。创新的包装设计，消费者可以自行施工，直接涂抹覆盖即可轻松焕新老旧的密封胶层。', cover: 'static/images/furniture_5_2_2.jpg', dot: true },
        { title: '百得免钉胶高级环保型​Pattex PL70 Pro', intro: '光固化丙烯酸胶粘剂,升级配方，无溶剂更环保。小支包装挥别施工工具，可以轻松粘结安装各种材质物品，免去钉钉子的烦恼。', cover: 'static/images/furniture_5_2_3.jpg', dot: true }
      ]
    }
  ],
  textile: [
    {
      title: '应用于挡风雨条的汉高解决方案',
      cover: '',
      text: [
        { title: '', content: '汉高的防水饰条防滑涂料，快速且易应用。有效改善附着力，减少浪费和降噪。', desc: '' }
      ],
      list: []
    },
    {
      title: '汉高车灯解决方案',
      cover: '',
      text: [
        { title: '', content: '汉高提供适用于车灯装配和辅助零部件的粘结和发泡密封的全系列产品，如反应性 热熔、聚氨酯和其他结构胶产品。', desc: '' }
      ],
      list: []
    }
  ]
}

export const dataAdhesiveList = [
  { id: 1, title: '家用电器行业解决方案', name: 'appliances' },
  { id: 2, title: '汽车行业解决方案', name: 'car' },
  { id: 3, title: '消费电子行业解决方案', name: 'consume' },
  { id: 4, title: '医疗行业解决方案', name: 'medical' },
  { id: 5, title: '家具与建材行业解决方案', name: 'furniture' },
  { id: 6, title: '纺织行业解决方案', name: 'textile' },
  { id: 7, title: '通用工业解决方案', name: 'industry' }
]
